export default class Validationinputonlynumber {
  inputnumberKeyPress = (e) => {
    var k = e.which;
    var ok =
      (k >= 48 && k <= 57) || // 0-9
      k === 8 || // Backspaces
      k === 9 || //H Tab
      k === 11 || //V Tab
      k === 0 || // Tab for Firefox
      k === 127; //Delete
    if (!ok) {
      e.preventDefault();
    }
  };
  inputCharcterKeyPress = (e) => {
    var k = e.which;
    var ok =
      (k > 64 && k < 91) ||
      (k > 96 && k < 123) || // 0-9
      k === 8 || // Backspaces
      k === 9 || //H Tab
      k === 11 || //V Tab
      k === 0 || // Tab for Firefox
      k === 127; //Delete
    if (!ok) {
      e.preventDefault();
    }
  };
}
